import { render, staticRenderFns } from "./WhiteRecord.vue?vue&type=template&id=51a781d0&"
import script from "./WhiteRecord.vue?vue&type=script&lang=js&"
export * from "./WhiteRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports